/**
 * @generated SignedSource<<2c3c12829e9dfd96379b6dadcdacfcd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeaturedContentGrid_featuredContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocksPerRow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeaturedContentBlock",
      "kind": "LinkedField",
      "name": "featuredContentBlocks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FeaturedContentBlock_block"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionFeaturedContent",
  "abstractKey": null
};

node.hash = "6473c00b9b0dc92c445706658258f441";

module.exports = node;
